import useDi from '../useDi'

import Token from '@/di/di.token'

export default function useEmailService() {
  const { container } = useDi()
  const service = container.get(Token.EMAIL_SERVICE)
  return { service }
}
